import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelSlides: [],
    sexualAspectId: '',
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelSlides: (state) => state.modelSlides,
    sexualAspectId: (state) => state.sexualAspectId,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelSlides = Array.isArray(recordsData?.modelSlides) ? recordsData.modelSlides : [];
      state.sexualAspectId = recordsData?.sexualAspectId ? recordsData.sexualAspectId : '';
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.caxASXxSexualSchema(),
          apiClient.catCurrentSexes(),
          apiClient.catGenders(),
          apiClient.catSexOrientation(),
          apiClient.catSexRelationship(),
          apiClient.catFrequency(),
          apiClient.catSexDysfAcquisition(),
          apiClient.catSexDysfSituation(),
          apiClient.catSexCondition(),
          apiClient.catSexParaphiliasSpec(),
          apiClient.catSexContraceptive(),
        ]);
        const [
          schemaRes,
          catCurrentSexes,
          catGenders,
          catSexOrientation,
          catSexRelationship,
          catFrequency,
          catSexDysfAcquisition,
          catSexDysfSituation,
          catSexCondition,
          catSexParaphiliasSpec,
          catSexContraceptive,
        ] = responses.map((res) => res?.data ?? {});

        let id1 = 'B';
        const resCat14 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionB = resCat14.data.data;

        let id2 = 'D';
        const resCat15 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionD = resCat15.data.data;

        if (!schemaRes.schemaFormItems) throw new Error('Estructura de schema inválida.');

        let schema = structuredClone(schemaRes);
        schema.schemaFormItems[0].schemaForm.group1.schema.current_sexes_current_sexes_id.items =
          catCurrentSexes.data ?? [];
        schema.schemaFormItems[0].schemaForm.group1.schema.genders_genders_id.items =
          catGenders.data ?? [];
        schema.schemaFormItems[0].schemaForm.group1.schema.sex_orientation_sex_orientation_id.items =
          catSexOrientation.data ?? [];
        schema.schemaFormItems[0].schemaForm.group1.schema.sex_relationship_model_id.items =
          catSexRelationship.data ?? [];
        schema.schemaFormItems[0].schemaForm.group2.schema.sex_masturbation_frequency_id.items =
          catFrequency.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.sex_satisfaction_level_description_id.items =
          catLevelDescriptionD;
        schema.schemaFormItems[1].schemaForm.group1.schema.i1_sex_phases_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.group1.schema.i1_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i1_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i2_sex_phases_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.group1.schema.i2_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i2_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i3_sex_phases_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.group1.schema.i3_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i3_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i4_sex_phases_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.group1.schema.i4_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i4_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i5_sex_phases_level_description_id.items =
          catLevelDescriptionB;
        schema.schemaFormItems[1].schemaForm.group1.schema.i5_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i5_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i6_sex_phases_dysf_t_a.items =
          catSexDysfAcquisition.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.i6_sex_phases_dysf_g_s.items =
          catSexDysfSituation.data ?? [];
        schema.schemaFormItems[1].schemaForm.group1.schema.sex_condition.items =
          catSexCondition.data ?? [];
        schema.schemaFormItems[2].schemaForm.group1.schema.sex_paraphilias_spec.items =
          catSexParaphiliasSpec.data ?? [];
        schema.schemaFormItems[2].schemaForm.group2.schema.sex_contraceptive.items =
          catSexContraceptive.data ?? [];

        let modelFormItems = [
          { modelForm: { group1: {}, group2: {} } },
          { modelForm: { group1: {} } },
          { modelForm: { group1: {}, group2: {} } },
        ];

        let modelSlides = modelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        const isNewRecord = true;
        const recordsData = { modelSlides, isNewRecord };
        commit('SET_SCHEMA', schema);
        commit('SET_RECORDS', recordsData);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState, getters, dispatch }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelCAxASXxSexual(clinicalHistories_id, institutions_profes_id);
        let recordsData = res?.data?.data ?? {};
        const dataModelFormItems = recordsData.modelSlides;

        if (Object.keys(getters.schema).length === 0) {
          await dispatch('fetchSchema');
        }
        const schema = JSON.parse(JSON.stringify(getters.schema));

        let modelSlides = dataModelFormItems.map((item, i) => ({
          modelForm: item.modelForm,
          schemaForm: schema.schemaFormItems[i].schemaForm,
        }));

        if (recordsData.isNewRecord === true) {
          modelSlides.sexual_aspect_id = dataModelFormItems[0].modelForm.sexual_aspect_id;
        }

        recordsData.modelSlides = modelSlides;
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createCAxASXxSexual(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const preparedModel = prepareModel(rootState, model);
        const id = model.sexualAspectId;
        await apiClient.updateCAxASXxSexual(id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
